define('viewModels/privileged/qm/policies/editors/MediaTypeEditorView',[
    'lib/lodash4',
    'lib/knockout',
    'services/qualityManagementService',
    'viewModels/privileged/qm/policies/editors/CheckedListEditorView'
], function (_, ko, qualityManagementService, CheckedListEditorView) {
    'use strict';

    /**
     * The MediaTypeEditorView class.
     * @class
     */
    var MediaTypeEditorView = CheckedListEditorView.extend(function (mediaTypesObservable) {
        var self = this;

        self.allMediaTypesList = ko.observableArray();
        self.selectedMediaTypesList = ko.observableArray();

        self.mediaTypes = mediaTypesObservable.extend({deepComparer: true, minItems: {params: 1, message: "mediaTypeEditorView.noMediaTypeSelected"}});

        self.getDisplayString = function (item) {
            return item.display;
        };

        qualityManagementService.getRecordingMediaTypes().then(function (mediaTypesData) {
            self.allMediaTypesList(mediaTypesData());

            self.selectedMediaTypesList(_.reduce(self.mediaTypes(), function (mediaTypes, mediaTypeKey) {
                var mediaType = _.find(self.allMediaTypesList(), function (mediaTypeItem) {
                    return mediaTypeItem.id == ko.unwrap(mediaTypeKey);
                });

                if (mediaType) {
                    mediaTypes.push(mediaType);
                }
                return mediaTypes;
            }, []));

            self.computed(function() {
                var unwrapped = ko.unwrap(self.selectedItemsList);
                self.mediaTypes(_.map(unwrapped, "id"));
            });

            self.init(self.allMediaTypesList(), self.selectedMediaTypesList());
        });
    });

    return MediaTypeEditorView;
});

